export default __webpack_public_path__ + "static/media/profile.111a8d90.png";